import { useState, useEffect } from "react";
import React, { Fragment } from "react";
import { Container, Col, Row } from "bootstrap-4-react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Mousewheel, EffectFade, Thumbs, Navigation, Pagination } from "swiper";
import axios from "axios";
import * as apiUrl from "../../../apiUrl";

// swiper bundle styles
import "swiper/swiper-bundle.min.css";
// swiper core styles
import "swiper/swiper.min.css";
// images
// import slideImage1 from "./../../../assets/img/2020_Properties_Assets-03.jpg";
// import slideImage2 from "./../../../assets/img/2020_Properties_Assets-04.jpg";
// import slideImage3 from "./../../../assets/img/2020_Properties_Assets-05.jpg";
import slideImage5 from "./../../../assets/img/2020_Properties_Assets-Amenities-txt.svg";
import { useParams } from "react-router-dom";
SwiperCore.use([Mousewheel, EffectFade, Thumbs, Navigation, Pagination]);




export default function PropertiesAmentiesSwiper() {

  const { id } = useParams();

  const [data, setData] = useState({
    formValues1: [
      {
        section_id: "",
        slider_image: [],
        imageURL: "",
        section_title: "",
        section_description: "",
      },
    ],
    errors5: [{ section_id: "", slider_image: "" }],
    selectedFiles7: undefined,
    currentFile7: undefined,
    imageURL: "",
    section_title: "",
    section_description: "",
  });
  const [thumbsSwiper, setThumbsSwiper] = useState(null);


  useEffect(()=>{

    //code here
    // when userName state change it will call 
    
    axios
      .post(
        apiUrl.apiUrl +
          "/propertiesinnerpage/edit_propertiesinner_post/" +
          id
      )
      .then((res) => {
        let formValues1 = [];
          res.data[0].pipt.forEach((element) => {
            element.imageURL =
              apiUrl.apiUrl +
              "/mvd/propertiesinnerpagepostsection/" +
              element.slider_image;
           
             
            formValues1.push(element);
            // console.log("formvaluesL: ",values);   
          });
        let dataxx = [];
        // dataxx.section_title7 = res.data[0].section_title7;
        dataxx.formValues1 = formValues1;
        setData(dataxx);
      });

},[id])


  useEffect(() => {
    let self = this;

    
   
    axios
      .post(
        apiUrl.apiUrl +
          "/propertiesinnerpage/edit_propertiesinner_post/" +
          id
      )
      .then((res) => {
        let formValues1 = [];
          res.data[0].pipt.forEach((element) => {
            element.imageURL =
              apiUrl.apiUrl +
              "/mvd/propertiesinnerpagepostsection/" +
              element.slider_image;
           
             
            formValues1.push(element);
            // console.log("formvaluesL: ",values);   
          });
        let dataxx = [];
        // dataxx.section_title7 = res.data[0].section_title7;
        dataxx.formValues1 = formValues1;
        setData(dataxx);
      });
  }, []);

  console.log("formvalues1",data.formValues1);

  console.log(typeof(data.formValues1));


  let imageurl = []
console.log("url",imageurl);
  return (
    <Fragment>
      <section className="propertiesAmentiesSwiper commonSec">
        {/* <div className="sideImg">
          <img src={slideImage5} className="img-fluid" alt="" />
        </div> */}

      {data.formValues1.map((item)=>{
        <p>{item.imageURL}</p>
      })}


        <Container Fluid>
          <Row>
            <Col md={7}>
            <Swiper
                slidesPerView={1}
                spaceBetween={50}
                onSwiper={setThumbsSwiper}
                speed={1000}
                autoplay={false}
                // noSwiping={true}
                effect={"fade"}
                loop={true}
                className="property-image-swiper"
              >
                {data.formValues1.map((item)=>(
                  <SwiperSlide>
                  <div className="property-amenity-image">
                    <img src={item.imageURL} className="img-fluid" alt="" />
                  </div>
                </SwiperSlide>
                ))}
                {/* <SwiperSlide>
                  <div className="property-amenity-image">
                    <img src={slideImage2} className="img-fluid" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="property-amenity-image">
                    <img src={slideImage1} className="img-fluid" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="property-amenity-image">
                    <img src={slideImage3} className="img-fluid" alt="" />
                  </div>
                </SwiperSlide> */}
              </Swiper>
            </Col> 
            <Col md={5} className="d-flex align-items-center">
             
              <Swiper
                thumbs={{ swiper: thumbsSwiper }}
                spaceBetween={50}
                slidesPerView={1}
                mousewheel={false}
                autoplay={false}
                speed={1000} 
                loop={true} 
                effect={"fade"}
                navigation={true}
                // pagination={true}
                className="property-desc-swiper"
              >
               { data.formValues1.map((item=>(
              <SwiperSlide>
              <div className="amenities-description">
                <h2 className="canelaMedium darkBlue">{item.section_title}</h2>
                <p>
                  {item.section_description}
                </p>
              </div>
            </SwiperSlide>
               )))}
{/*                 
                <SwiperSlide>
                  <div className="amenities-description">
                    <h2 className="canelaMedium">Leisure Deck</h2>
                    <p>
                      The Leisure Deck is the ideal place to sit back, cool off,
                      and enjoy a refreshing beverage or a light snack.
                      Especially during the cooler months, the Leisure Deck is a
                      great hideaway from work stress and traffic.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="amenities-description">
                    <h2 className="canelaMedium">Swimming Pool</h2>
                    <p>
                      The immaculate swimming pool on the first floor is nice
                      and quiet. If you want to learn or enjoy an evening dip,
                      this is the place to be. Invite friends and family over
                      and make a day out of it.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="amenities-description">
                    <h2 className="canelaMedium">Kids Play Area</h2>
                    <p>
                      We haven’t forgotten about you. Yes we are talking about
                      you kids. Let your children enjoy and play around in the
                      kid’s pool while you adults have a peaceful swim in your
                      pool.
                    </p>
                  </div>
                </SwiperSlide> */}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
}
